// Please make sure to keep enum values in alphabetical order

export enum CustomComponentName {
  ABOUT = 'About',
  ACCORDIAN = 'Accordion',
  ACCORDIAN_PANEL = 'AccordionPanel',
  AVATAR_IMAGE = 'AvatarImage',
  BAMBEE_LOGO = 'Bambee Logo',
  BASE_BUTTON = 'BaseButton',
  BASE_CARD = 'BaseCard',
  BASE_DIVIDER = 'BaseDivider',
  BASE_ICON = 'BaseIcon',
  BENEFITS_BLADE = 'BenefitsBlade',
  BLAND_HERO = 'Bland Hero',
  BLOG_CATALOG = 'Blog Catalog',
  COMPLIANCE = 'Compliance',
  COMPLIANCE_TEMPLATE = 'Compliance Template',
  CONTENT_CARD = 'Content Card',
  CTA_BLADE = 'CTA Blade',
  DOWNLOADS = 'Downloads',
  EMPLOYEE_DROPDOWN = 'EmployeeDropdown',
  FACTOID = 'Factoid',
  FAQ = 'FAQ',
  FAQROOT = 'FAQRoot',
  FEATURE_SUMMARY = 'Feature Summary',
  HOME_HERO = 'HomeHero',
  HOME_NAV = 'HomeNav',
  INDUSTRIES = 'Industries',
  INDUSTRY_TEMPLATE = 'Industry Template',
  INSURANCE = 'Insurance',
  LEGAL = 'Legal',
  LEGAL_TEMPLATE = 'Legal Template',
  MOBILE_MEMU = 'MobileMenu',
  PAGE_HERO = 'Page Hero',
  PAGE_SUB_HERO = 'Page Sub Hero',
  PARTNERS = 'Partners',
  PARTNERSHIP_PAGE = 'Partnership Page',
  PRICING = 'Pricing',
  PRICING_PLANS = 'PricingPlans',
  PRODUCT = 'Product',
  PURPLE_HEX_CONTAINER = 'Purple Hex Container',
  PROFILE_CARD = 'Profile Card',
  PROFILE_FACTOID = 'Profile Factoid',
  REFERRED_BLOGS = 'Referred Blogs',
  REGISTRATION_PROMPT = 'RegistrationPrompt',
  REVIEWS = 'Reviews',
  ROOT_HOMEPAGE = 'RootHomePage',
  SCHEDULE_CALL = 'Schedule Call',
  SIMPLE_FOOTER = 'Simple Footer',
  SIMPLE_IMAGE = 'Simple Image',
  SMART_IMAGE = 'Smart Image',
  TESTIMONIAL = 'Testimonial',
  TEXT_INPUT = 'TextInput',
  THE_FOOTER = 'TheFooter',
  TRAINING = 'Training',
  TYPE_BODY = 'TypeBody',
  TYPE_DISPLAY = 'TypeDisplay',
  TYPE_HEADING = 'TypeHeading',
  TYPE_OVERLINE = 'TypeOverline',
  VALUE_BLADE = 'Value Blade',
  ZIG_ZAG_LAYOUT = 'Zig Zag Layout',
  ZIG_ZAG_LAYOUT_CONTAINER = 'Zig Zag Layout Container',
}
